import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/checked.svg';

export const IconChecked = createIconComponent(Icon);
